module.exports = __webpack_public_path__ + "media/taipei/train_gaming-85b2939b.jpg";